<template>
  <div
    id="chatinput"
    style=" bottom: 0; right: 0; left: 0; "
    :style="{ position: isMobile ? 'fixed' : 'absolute' }"
  >
    <slot name="header"></slot>
    <div style="background: white;border-top: 1px solid #eee">
      <form v-on:submit.prevent="noop">
        <v-layout>
          <v-avatar size="30" class="ma-1">
            <img
              @error="onError"
              :src="
                'https://graph.facebook.com/' + selectedBot.pageid + '/picture?width=100&height=100'
              "
              style="border: 1px solid #eee"
            />
          </v-avatar>
          <v-flex class="pa-1">
            <autoresize-textarea
              v-model="text"
              rows="1"
              placeholder="Type message"
              style="resize: none;border: 1px solid #eee;  padding: 5px; border-radius: 5px;outline: 0px;background: none;    display: inline-block;"
            ></autoresize-textarea>
          </v-flex>
          <v-flex shrink class="text-xs-right" style="white-space: nowrap;">
            <!-- Send image -->
            <span>
              <v-dialog v-model="showUploadImg" max-width="700">
                <template v-slot:activator="{ on }">
                  <span>
                    <v-btn icon style="margin: 0" v-tooltip.top="'Send'" v-on="on">
                      <v-icon class="outlined">photo_size_select_actual</v-icon>
                    </v-btn>
                  </span>
                </template>
                <v-card>
                  <div class="text-xs-right">
                    <v-btn @click="showUploadImg = false" fab flat color="primary" small>
                      <v-icon>close</v-icon>
                    </v-btn>
                  </div>
                  <v-card-text v-if="showUploadImg">
                    <div>
                      <uploadfile
                        ref="answer"
                        v-model="image_url"
                        @onUploaded="onUploaded"
                        v-validate
                      ></uploadfile>
                    </div>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </span>
            <!-- End Send image -->
            <span>
              <v-btn
                depressed
                fab
                color="primary"
                small
                :disabled="!enableSend"
                @click="sendMessage"
                v-tooltip.top="'Send'"
              >
                <i class="fa fa-send"></i>
              </v-btn>
            </span>
          </v-flex>
        </v-layout>
      </form>
    </div>
  </div>
</template>

<script>
import AutoresizeTextarea from '@/components/elements/AutoresizeTextarea'
import { mapGetters } from 'vuex'
import Intent from '@/components/view/intent/Intent'
import uploadfile from '@/components/elements/uploadfile'

import api from '@/api'

export default {
  props: ['value', 'app'],
  data: function() {
    return {
      type: 'text',
      text: '',
      enableSend: false,
      user: this.value,
      isMobile: false,
      showIntent: false,
      showUploadImg: false,
      image_url: null
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  components: {
    AutoresizeTextarea,
    Intent,
    uploadfile
  },
  beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true })
    }
  },
  mounted: function() {
    this.onResize()
    window.addEventListener('resize', this.onResize, { passive: true })
  },
  methods: {
    onUploaded(url) {
      let data = {
        a_val: `[[{"image_url":"${url}","type":"image"}]]`,
        type: 'intent'
      }
      this.sendMessage(data)
      this.showUploadImg = false
      this.image_url = null
    },
    newline() {
      this.text = '${this.text}\n'
    },
    onError: function() {
      $(event.target).attr('src', '/static/img/assets/livechat/profile.png')
    },
    sendMessage: function(event) {
      this.showIntent = false
      let isIntent = event && event.type == 'intent'
      let vm = this
      if ((vm.enableSend == false || vm.selectedBot == null || vm.user == null) && !isIntent) {
        return false
      }
      let data = {
        pageid: vm.selectedBot.pageid,
        userid: vm.user.userid,
        app: vm.app,
        messagetype: isIntent ? 'json' : vm.type,
        messagevalue: isIntent ? event.a_val : vm.text,
        page_access_token: vm.selectedBot.page_access_token
      }

      let message = {
        answerby: 'admin',
        id: new Date().getTime(),
        messagedata: isIntent
          ? JSON.parse(event.a_val).length > 0
            ? JSON.stringify(JSON.parse(event.a_val)[0])
            : event.a_val
          : vm.text,
        messagetype: isIntent ? 'json' : vm.type,
        pageid: vm.selectedBot.pageid,
        timestamp: new Date(),
        userid: vm.user.userid
      }
      vm.$emit('onSendMessage', message)
      vm.text = ''

      api.sendMessage(data, function(error, response) {
        if (error) {
          console.error(error)
          // vm.$store.dispatch('loading')
          return
        }
        // vm.$store.dispatch('loading')
      })
    },
    onResize() {
      this.isMobile = window.innerWidth < 960
    }
  },
  watch: {
    text: function(newVal, oldVal) {
      if (newVal && newVal.trim() != '') {
        this.enableSend = true
      } else {
        this.enableSend = false
      }
    },
    value: function(newVal, oldVal) {
      this.user = this.value
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/livechat/livechat-chatinput.vue